/**
 * Инициализация секции с "Горячими предложениями".
 * 
 * @param { HTMLElement | null} $programs 
 */
const initProgrammsSection = ($programs) => {
	new Swiper($programs.querySelector('.programs__slider'), {
		slidesPerView: 'auto',
		navigation: {
			nextEl: $programs.querySelector('.bm-primary-section__slider-bottom-button--next'),
			prevEl: $programs.querySelector('.bm-primary-section__slider-bottom-button--prev'),
		},
		loop: true,
		speed: 600,
	});
}

const $programs = document.querySelector('#programs');

if ($programs) {
	initProgrammsSection($programs);
}

/**
 * Открыть модальное окно "Заявка отправлена".
 */
window.openSuccessModal = () => {}

/**
 * Закрыть модальное окно "Заявка отправлена".
 */
window.closeSuccessModal = () => {}

const initSuccessModals = () => {
	const $modal = document.querySelector('.modal[data-modal="bm-success"]');
	const closeModalTriggers = document.querySelectorAll("[data-close-modal]");
	
	window.openSuccessModal = () => {
		$modal.classList.add("is-active");
		$modal.classList.remove("is-closing");
	}
	
	window.closeSuccessModal = () => {
		$modal.classList.add("is-closing");
		$modal.classList.remove("is-active");
		setTimeout(() => {
			$modal.classList.remove("is-closing");
		}, 1000);
	}
	
	closeModalTriggers.forEach(trigger => {
		trigger.addEventListener("click", window.closeSuccessModal);
	});
	
	$modal.querySelector(".modal__overlay").addEventListener("click", window.closeSuccessModal, {passive: true});
}

initSuccessModals();

/**
 * Инициализация стандартной wpcf7 формы.
 * 
 * @param {HTMLFormElement} $form 
 */
const initCommonForm = ($form) => {
    $form?.addEventListener('wpcf7mailsent', (event) => {
        // Проверяем, что отправка прошла успешно
        if (event.detail.status === 'mail_sent') {
            window.openSuccessModal();
        }
    });
    
    // Дополнительно: можно обработать ошибки
    $form?.addEventListener('wpcf7mailfailed', (event) => {
        console.log('Ошибка отправки формы:', event.detail);
    });
}

const commonForms = document.querySelectorAll('.bm-form--common .wpcf7-form');
commonForms.forEach(initCommonForm);
// Инициализация одного видеоблока внутри галереи
const initGalleryPrimaryPlayer = ($container, $gallery, swiper) => {
  const $btnPlay = $container.querySelector('[data-player="button"]');
  const $cover   = $container.querySelector('[data-player="prev"]');
  const $video   = $container.querySelector('[data-player="desktop"]');

  if (!($btnPlay && $cover && $video)) return;

  const ensureSrc = () => {
    if (!$video.src) {
      const src = $video.getAttribute('data-video-src');
      if (src) $video.src = src;
    }
  };

  const pauseContainer = () => {
    $container.classList.remove('is-play');
    $video.pause();
  };

  const pauseAllInGallery = (except) => {
    $gallery.querySelectorAll('[data-player="container"]').forEach(($c) => {
      if (except && $c === except) return;
      const $v = $c.querySelector('[data-player="desktop"]');
      $c.classList.remove('is-play');
      if ($v) $v.pause();
    });
  };

  const playContainer = () => {
    ensureSrc();
    // Сначала останавливаем остальные, потом играем текущий
    pauseAllInGallery($container);
    $container.classList.add('is-play');
    $video.play().catch(() => {/* без звука/без взаимодействия — игнорируем */});
  };

  const togglePlay = (e) => {
    e.preventDefault();
    if ($container.classList.contains('is-play')) {
      pauseContainer();
    } else {
      playContainer();
    }
  };

  // События управления
  $btnPlay.addEventListener('click', togglePlay);
  $cover.addEventListener('click', togglePlay);

  // Ставим на паузу при скролле страницы
  const onScrollPause = () => pauseContainer();
  document.addEventListener('scroll', onScrollPause, { passive: true });

  // На смену слайда/перетаскивание — пауза
  if (swiper) {
    swiper.on('slideChangeTransitionStart', pauseContainer);
    swiper.on('touchStart', pauseContainer);
  }

  // Уход блока из зоны видимости — пауза
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) pauseContainer();
    });
  }, { threshold: 0.3 });
  io.observe($container);
};

// Инициализация одной секции .bm-gallery-primary
const initGalleryPrimarySection = ($gallery) => {
  const $swiper = $gallery.querySelector('.swiper');

  const swiper = new Swiper($swiper, {
    mousewheel: {
      enabled: true,
      sensitivity: 1,
      forceToAxis: true,
      releaseOnEdges: false,
    },
    freeMode: true,
    slidesPerView: 1.03,
    allowTouchMove: true,
    grabCursor: true,
    spaceBetween: 16,
    centeredSlides: true,
    navigation: {
      nextEl: $gallery.querySelector(".bm-primary-section__slider-bottom-button--next"),
      prevEl: $gallery.querySelector(".bm-primary-section__slider-bottom-button--prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 1.345,
        spaceBetween: 42,
        slidesOffsetBefore: 0,
        centeredSlides: false,
      },
    },
    on: {
      // Подставляем src из data-video-src (если не задан) после инициализации
      afterInit: function () {
        $swiper.querySelectorAll("video").forEach((video) => {
          if (!video.src) {
            const s = video.getAttribute("data-video-src");
            if (s) video.src = s;
          }
        });
      },
    },
  });

  // Инициализируем плееры внутри текущей галереи
  $gallery
    .querySelectorAll('[data-player="container"]')
    .forEach(($container) => initGalleryPrimaryPlayer($container, $gallery, swiper));
};

// Инициализация всех секций на странице
const $galleryPrimarySections = document.querySelectorAll('.bm-gallery-primary');
$galleryPrimarySections.forEach(initGalleryPrimarySection);

